import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Checkbox, FormCheck, FormCheckLabel, ControlFeedback, Radio, RadioGroup } from '@smooth-ui/core-em'
import pick from 'lodash.pick'
import queryString from 'query-string'
import { Input, Box, Space, Button } from 'UILibrary'
import LocationAutoComplete from '../../../components/LocationAutoComplete'
import { trackEvent, validationMessage, firstTimeFreeUser } from 'utils'
import styled, { css } from 'react-emotion'
import zxcvbn from 'zxcvbn'
import { EMAIL_REGEX, PHONE_REGEX, ZIP_REGEX, PLANS, REGISTER, ROUTES_PATH, MESSAGE } from '../../../constants'
import Loader from '../../../components/Loader'
import { Link } from 'react-router-dom'
import CheckoutForm from 'features/payment/components/CheckoutForm'
import InfoIcon from '@material-ui/icons/Info'
import { Tooltip } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'

const expandedUserFields = ['firstName', 'lastName', 'email', 'phone', 'password', 'location', 'zip']
const abbreviatedUserFields = ['firstName', 'lastName', 'email', 'location', 'phone', 'zip']
const formFields = expandedUserFields.concat(['passwordConfirmation', 'agreeTermsAndConditions', 'planSelection'])

const backTosignInBtn = css({
  fontSize: '14px',
})
const formContainer = css({
  marginTop: '5px',
  marginBottom: '5px',
  '.registeRadiobox': {
    display: 'flex',
    margin: '20px 0 0',
  },
  '.radioButtons': {
    fontSize: '14px',
    color: '#555',
    marginRight: '25px',
    '.radiolabel': {
      input: {
        cursor: 'pointer',
      },
    },
  },
  '.registercheckbox': {
    input: {
      cursor: 'pointer',
    },
  },
  '.registeAnchorlink': {
    background: '#fffbe8',
    padding: '16px 20px',
    margin: '10px 0 20px',
    a: {
      color: '#00bcb5',
      fontSize: '14px',
      textDecoration: 'none',
    },
  },
  '.termsConditionslink': {
    color: '#00bcb5',
    textDecoration: 'none',
  },
  '.registerButtonBar': {
    'button:disabled': {
      cursor: 'default',
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
  '.hover': {
    cursor: 'pointer',
    '&>p': {
      marginTop: 0,
    },
  },
})
const investmentLabel = css({
  display: 'flex',
  alignItems: 'center',
  padding: '10px 0 10px 0',
})
const removeLocationIcon = css({
  position: 'absolute',
  top: 0,
  transform: 'translate(0,75%)',
  right: '6px',
  color: '#cacac1',
  cursor: 'pointer',
  fontSize: 'large!important',
  marginLeft: '1em',
})

const StyledTooltip = styled(({ className, ...other }) => {
  return <Tooltip classes={{ tooltip: className }} {...other} />
})`
  font-size: 0.8em;
  height: 30px;
  padding: 1em;
  display: flex;
  align-items: center;
  background-color: black;
`
class Register extends React.Component {
  constructor(props) {
    super(props)
    this.state = formFields.reduce((output, field) => ({ ...output, [field]: '' }), { errors: {}, showDetail: false, stripeToken: null })
  }
  removePlanSelectionField() {
    const index = formFields.findIndex(field => field === 'planSelection')
    formFields.splice(index, 1)
  }

  componentDidMount() {
    const abbreviatedRegistration = this.props.socialAuthToken && !queryString.parse(this.props.location.search).expanded

    if (abbreviatedRegistration) {
      let userq = [
        ['email', this.props.user.get('email')],
        ['firstName', this.props.user.get('firstName')],
        ['lastName', this.props.user.get('lastName')],
        ['zip', this.props.user.get('zip')],
        ['phone', this.props.user.get('phone')],
        ['location', this.props.user.get('location')],
      ]
      const validUserFields = userq.filter(([name, value]) => abbreviatedUserFields.includes(name) && !this.validateField(name, value)).map(([name, _]) => name)
      this.setState({
        abbreviatedRegistration,
        abbreviatedUserFieldsPresent: validUserFields,
        email: this.props.user.get('email'),
        firstName: this.props.user.get('firstName'),
        lastName: this.props.user.get('lastName'),
        zip: this.props.user.get('zip'),
        phone: this.props.user.get('phone'),
        location: this.props.user.get('location'),
      })
    }
    this.props.hidePremium && this.removePlanSelectionField()
    this.setState({
      locations: [{ location: '' }, { location: '' }],
    })
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.type === 'radio' ? target.name : target.id
    const value = target.type === 'checkbox' ? target.checked : target.value

    this.setState(
      state => ({
        [name]: value,
        errors: { ...state.errors, [name]: this.validateField(name, value) },
      }),
      () => this.validatePasswordMatch(name, value)
    )
  }

  validatePasswordMatch = (name, value) => {
    const confirmPasswordValue = this.state.passwordConfirmation
    if (name === 'password' && confirmPasswordValue) {
      this.setState(state => ({
        errors: {
          ...state.errors,
          passwordConfirmation: value !== confirmPasswordValue ? "doesn't match" : '',
        },
      }))
    }
  }

  validateField = (name, value) => {
    if (value === null || value === undefined) {
      return 'is invalid'
    } else if (!value) {
      return 'is missing'
    }

    switch (name) {
      case 'firstName':
      case 'lastName':
      case 'planSelection': {
        if ('' === value.trim()) {
          return 'is invalid'
        }
        break
      }
      case 'location': {
        if ('' === value.trim()) {
          return 'is invalid'
        }
        break
      }
      case 'password': {
        let errorMessage = validationMessage(zxcvbn(value))
        if (8 > value.length) {
          return 'is too short'
        }
        if (errorMessage !== '') {
          return errorMessage
        }
        break
      }
      case 'passwordConfirmation': {
        if (value !== this.state.password) {
          return "doesn't match"
        }
        break
      }
      case 'email': {
        if (null === value.match(EMAIL_REGEX)) {
          return 'is invalid'
        }
        break
      }
      case 'phone': {
        if (!value.match(PHONE_REGEX) || value.length < 9) {
          return 'is invalid'
        }
        break
      }
      case 'zip': {
        if (null === value.match(ZIP_REGEX)) {
          return 'is invalid'
        }
        break
      }
      default:
        break
    }
  }

  isValid = () => {
    //FIXME
    const fields = this.state.abbreviatedRegistration || this.props.showOnMainPage ? abbreviatedUserFields.concat(['agreeTermsAndConditions']) : formFields
    return fields.reduce((a, f) => a && this.state[f] && !this.state.errors[f], true)
  }

  handleSelect = (location, placeID) => {
    // placeID is null when user press Enter Key and doesnt select a value
    this.setState(state => ({
      location,
      errors: { ...state.errors, locations: [{ location: 'location_' + state.selectedIndex, error: this.validateField('location', placeID) }] },
    }))
    this.updateLocations(location)
  }

  handleSubmit = event => {
    event.preventDefault()
    if (this.isValid()) {
      // open the payment form if premium is selected
      this.state.planSelection === PLANS.PREMIUM ? this.toggleDetail() : this.continueToRegister()
    }
  }

  async continueToRegister(from = null) {
    try {
      let dataToBeRegister = pick(this.state, this.state.abbreviatedRegistration ? abbreviatedUserFields : expandedUserFields)
      dataToBeRegister.location = this.state.locations.map(loc => loc.location)
      if (this.state.planSelection === PLANS.PREMIUM) {
        dataToBeRegister['stripeToken'] = this.state.stripeToken
      }
      const socialOauth = this.state.abbreviatedRegistration
        ? {
            OAuthProvider: this.props.OAuthProvider,
            socialAuthToken: this.props.socialAuthToken,
          }
        : {}

      const response = await this.props.createUser(dataToBeRegister, socialOauth)
      if (response.errors) {
        this.props.showFlashMessage(
          true,
          response.errors
            .map(field => {
              return typeof field !== 'string' ? `${field[0]} ${field[1].join(' ')}` : field
            })
            .join(';')
        )
      } else if (response.token) {
        trackEvent({
          category: REGISTER,
          action: this.state.abbreviatedRegistration ? this.props.OAuthProvider.toLowerCase() + ' Social Registration' : 'Website Registration',
        })
        //this likely to happen if its a socialOauth registration flow
        if (from === 'payment') {
          this.props.showFlashMessage(null, MESSAGE.PREMIUM_MEMBER)
          this.props.history.push({ pathname: ROUTES_PATH.HOME })
        } else if (firstTimeFreeUser(response.user) && !this.props.hidePremium) {
          this.props.history.push(ROUTES_PATH.WELCOME)
        } else {
          this.props.history.push({ pathname: ROUTES_PATH.HOME, search: `?logged=true` })
        }
      } else {
        from === 'payment' && this.props.showFlashMessage(null, MESSAGE.PREMIUM_MEMBER)
        //this likely to happen if its a mail/password registration flow
        this.props.history.push({ pathname: '/auth/verify', search: `?email=${response.user.email}` })
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error, MESSAGE.CONTACT_ADMIN)
    }
  }

  shouldRequireField(field, alredyPresentFields) {
    return !alredyPresentFields || !alredyPresentFields.includes(field)
  }

  toggleDetail() {
    const { showDetail } = this.state
    this.setState({
      showDetail: !showDetail,
    })
  }

  onTokenCreate(token) {
    this.setState({ stripeToken: token })
    this.continueToRegister('payment')
  }
  updateLocations(value) {
    const { selectedIndex } = this.state
    this.setState(state => ({
      locations: state.locations.map((loc, index) => {
        if (index !== selectedIndex) return loc
        return { ...loc, location: value }
      }),
    }))
  }
  addMoreLocation() {
    this.setState(state => {
      return {
        locations: state.locations.concat([{ location: '' }]),
      }
    })
  }
  setSelectedIndex(idx) {
    this.setState({
      selectedIndex: idx,
    })
  }
  checkError(errors, idx) {
    const err = errors.locations && errors.locations.find(loc => loc.location === 'location_' + idx)
    if (err) return err.error
    return null
  }

  removeLocation(idx) {
    if (this.state.locations.length <= 1) return
    this.setState(state => {
      return {
        locations: state.locations.filter((_, index) => index !== idx),
      }
    })
  }
  render() {
    const { isLoading } = this.props
    const {
      firstName,
      lastName,
      email,
      phone,
      password,
      passwordConfirmation,
      zip,
      agreeTermsAndConditions,
      abbreviatedRegistration,
      abbreviatedUserFieldsPresent,
      errors,
      showDetail,
      planSelection,
      locations,
    } = this.state

    return (
      <Box p={'m'}>
        <form className={formContainer} onSubmit={this.handleSubmit}>
          <Box display="flex" flexDirection="row">
            <Box flexGrow={1 / 2}>
              <FormGroup>
                <Input
                  id="firstName"
                  control
                  placeholder="First Name"
                  value={firstName}
                  onChange={this.onFormFieldChange}
                  valid={errors.firstName ? false : null}
                  maxLength="40"
                />
                {errors.firstName && <ControlFeedback valid={false}>{errors.firstName}</ControlFeedback>}
              </FormGroup>
            </Box>
            <Space kind="inline" size="m" />
            <Box flexGrow={1 / 2}>
              <FormGroup>
                <Input
                  id="lastName"
                  control
                  placeholder="Last Name"
                  value={lastName}
                  onChange={this.onFormFieldChange}
                  valid={errors.lastName ? false : null}
                  maxLength="80"
                />
                {errors.lastName && <ControlFeedback valid={false}>{errors.lastName}</ControlFeedback>}
              </FormGroup>
            </Box>
          </Box>
          {this.shouldRequireField('email', abbreviatedUserFieldsPresent) && (
            <FormGroup>
              <Input
                id="email"
                type="email"
                maxLength="80"
                control
                placeholder="Email Address"
                value={email}
                onChange={this.onFormFieldChange}
                valid={errors.email ? false : null}
              />
              {errors.email && <ControlFeedback valid={false}>{errors.email}</ControlFeedback>}
            </FormGroup>
          )}
          {!abbreviatedRegistration && (
            <Box display="flex" flexDirection="row">
              <Box flexGrow={1 / 2} maxWidth="49%">
                <FormGroup>
                  <Input
                    id="password"
                    type="password"
                    control
                    placeholder="Password"
                    value={password}
                    onChange={this.onFormFieldChange}
                    valid={errors.password ? false : null}
                  />
                  {errors.password && <ControlFeedback valid={false}>{errors.password}</ControlFeedback>}
                </FormGroup>
              </Box>
              <Space kind="inline" size="m" />
              <Box flexGrow={1 / 2} minWidth="49%">
                <FormGroup>
                  <Input
                    id="passwordConfirmation"
                    type="password"
                    control
                    placeholder="Confirm Password"
                    value={passwordConfirmation}
                    onChange={this.onFormFieldChange}
                    valid={errors.passwordConfirmation ? false : null}
                  />
                  {errors.passwordConfirmation && <ControlFeedback valid={false}>{errors.passwordConfirmation}</ControlFeedback>}
                </FormGroup>
              </Box>
            </Box>
          )}
          <Box display="flex" flexDirection="row">
            <Box flexGrow={1 / 2} maxWidth="49%">
              {this.shouldRequireField('phone', abbreviatedUserFieldsPresent) && (
                <FormGroup>
                  <Input
                    id="phone"
                    maxLength="40"
                    control
                    placeholder="Phone"
                    value={phone}
                    onChange={this.onFormFieldChange}
                    valid={errors.phone ? false : null}
                  />
                  {errors.phone && <ControlFeedback valid={false}>{errors.phone}</ControlFeedback>}
                </FormGroup>
              )}
            </Box>
            <Space kind="inline" size="m" />
            <Box flexGrow={1 / 2} minWidth="49%">
              {this.shouldRequireField('zip', abbreviatedUserFieldsPresent) && (
                <FormGroup>
                  <Input id="zip" control placeholder="Zip Code" value={zip} onChange={this.onFormFieldChange} valid={errors.zip ? false : null} />
                  {errors.zip && <ControlFeedback valid={false}>{errors.zip}</ControlFeedback>}
                </FormGroup>
              )}
            </Box>
          </Box>
          {this.shouldRequireField('location', abbreviatedUserFieldsPresent) && (
            <React.Fragment>
              <div className={investmentLabel}>
                Investment Locations&nbsp;
                <StyledTooltip arrow="true" placement="right" title={MESSAGE.INVESTMENT_LOCATION_TOOLTIP}>
                  <InfoIcon />
                </StyledTooltip>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {locations &&
                  locations.map((loc, idx) => {
                    return (
                      <div
                        key={idx}
                        style={{
                          position: 'relative',
                          width: '224.5px',
                          maxWidth: '225px',
                          display: 'inline-block',
                          marginLeft: idx % 2 === 1 ? '8px' : '0px',
                        }}>
                        <FormGroup key={`${loc}_${idx}`} style={{ position: 'relative', width: '100%' }}>
                          <LocationAutoComplete location={loc.location} formFieldChange={this.onFormFieldChange} locationSelection={this.handleSelect}>
                            <Input
                              onFocus={() => this.setSelectedIndex(idx)}
                              id={'location_' + idx}
                              placeholder="Investment Location"
                              control
                              valid={this.checkError(errors, idx) ? false : null}
                            />
                          </LocationAutoComplete>
                          <ClearIcon onClick={() => this.removeLocation(idx)} className={removeLocationIcon} />
                          {this.checkError(errors, idx) && <ControlFeedback valid={false}>{this.checkError(errors, idx)}</ControlFeedback>}
                        </FormGroup>
                      </div>
                    )
                  })}
              </div>
              <div className="termsConditionslink hover">
                <p onClick={this.addMoreLocation.bind(this)}>+ Add another location</p>
              </div>
            </React.Fragment>
          )}
          {!this.props.hidePremium && (
            <div className="registeRadiobox">
              <RadioGroup>
                <FormCheck className="radioButtons">
                  <Radio
                    valid={errors.planSelection ? false : null}
                    size="sm"
                    className="radiolabel"
                    id="sizeRadio1"
                    name="planSelection"
                    value={PLANS.FREE}
                    onChange={this.onFormFieldChange}
                    checked={planSelection === PLANS.FREE}
                  />
                  <FormCheckLabel className="radiolabel" htmlFor="sizeRadio1">
                    {PLANS.FREE}
                  </FormCheckLabel>
                </FormCheck>
                <FormCheck className="radioButtons">
                  <Radio
                    valid={errors.planSelection ? false : null}
                    size="sm"
                    className="radiolabel"
                    id="sizeRadio2"
                    name="planSelection"
                    value={PLANS.PREMIUM}
                    onChange={this.onFormFieldChange}
                    checked={planSelection === PLANS.PREMIUM}
                  />
                  <FormCheckLabel className="radiolabel" htmlFor="sizeRadio2">
                    {PLANS.PREMIUM}
                  </FormCheckLabel>
                </FormCheck>
              </RadioGroup>
            </div>
          )}
          {!this.props.hidePremium && (
            <div className="registeAnchorlink">
              <Link to={ROUTES_PATH.PRICING} target="_blank">
                Learn more about pricing - $29.99/month
              </Link>
            </div>
          )}
          <FormCheck className="registercheckbox">
            <Checkbox
              name="agreeTermsAndConditions"
              alignSelf="flex-start"
              id="agreeTermsAndConditions"
              borderColor="gray"
              checked={Boolean(agreeTermsAndConditions)} // Type cast nullish value to bool for prop type validation
              onChange={this.onFormFieldChange}
            />
            <FormCheckLabel htmlFor="basicCheckbox1">
              As an Investor, I agree to the{' '}
              <a target="_blank" href="/terms" className="termsConditionslink">
                Terms and Conditions.
              </a>
            </FormCheckLabel>
          </FormCheck>
          <Space size="xl" />
          <Box className="registerButtonBar" display="flex" justifyContent="space-between">
            {!this.props.showOnMainPage && (
              <Button className={backTosignInBtn} form back onClick={() => this.props.history.push({ pathname: '/', search: `?signin=true` })}>
                BACK TO SIGN IN
              </Button>
            )}
            <Space size="m" kind="inline" />
            <Button form success onClick={this.handleSubmit} disabled={!this.isValid()}>
              {isLoading ? <Loader color="white" /> : ' REGISTER'}
            </Button>
          </Box>
        </form>
        <CheckoutForm open={showDetail} onClose={() => this.toggleDetail()} from={REGISTER} onTokenCreate={token => this.onTokenCreate(token)} />
      </Box>
    )
  }
}

Register.propTypes = {
  createUser: PropTypes.func.isRequired,
  socialAuthToken: PropTypes.string,
  OAuthProvider: PropTypes.string,
  personalData: PropTypes.object,
  showFlashMessage: PropTypes.func.isRequired,
  showFlashMessageOnUnexpectedError: PropTypes.func.isRequired,
  showOnMainPage: PropTypes.bool,
}

export default Register



// WEBPACK FOOTER //
// ./src/features/authentication/components/Register.js